import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ApiService } from '@services/api/api.service';
import { NbToastrService } from '@nebular/theme';
import { IStockItemDetailFields } from '@common/domain/models/ext/StockItemDTOExt';
import { Paginator } from 'primeng/paginator';
import { ButtonsConfig, ButtonsStrategy, ButtonType } from '@ks89/angular-modal-gallery';
import { IdentityAuthService } from '@services/identity-auth/identity-auth.service';
import { Permissions } from 'src/app/config/AppEnums';
import { MfNestedFormsComponent } from '@framework/components/mf-nested-forms/mf-nested-forms.component';
import { SelectItem } from 'primeng/api';
import { appSettings } from '../../../../modules/shared/components/appSettings';

@Component({
  selector: 'app-stock-list',
  templateUrl: './stock-list.component.html',
  styleUrls: ['./stock-list.component.css']
})
export class StockListComponent implements OnInit {
  currentStartRec: number = 0;
  totalRecords: number;
  rowsPerPage: number = 50;
  formIndex: any;
  parent: any;
  public stockItemTypes: any = new Array();
  public _stockItemTypeId: any = null;
  public get stockItemTypeId() {
    return this._stockItemTypeId;
  };
  public set stockItemTypeId(value) {
    this._stockItemTypeId = value;
    this.loadData();
  }
  public listIndex; any;
  cardsView: boolean = true;
  _filteredSuppliers: any[];
  filterBySupplier: boolean = false;
  get filteredSuppliers() { return this._filteredSuppliers }
  set filteredSuppliers(value) { this._filteredSuppliers = value; if (this.filterBySupplier) this.loadData(); }
  suppliers: SelectItem[];
  stockItems: IStockItemDetailFields[];
  @ViewChild(Paginator, { static: true }) pager: Paginator;
  buttonsConfigSimple: ButtonsConfig = {
    visible: true,
    strategy: ButtonsStrategy.CUSTOM,
    buttons: [
      {
        className: 'fullscreen-image',
        type: ButtonType.FULLSCREEN
      },
      {
        className: 'close-image',
        type: ButtonType.CLOSE
      }
    ]
  };
  filteredBrands: any[];
  _search: any = '';
  get search() {
    return this._search;
  }
  set search(value) {
    this._search = value;
    if (!this._search || this.search == '') {
      this.loadData();

    }
  }
  loading: boolean = false;
	public addNew() {
		if (this.parent && this.parent.navigateToIndex)
			this.parent.navigateToIndex(this.parent.detailComponents[this.listIndex].bladeIndexToNavigateTo ? this.parent.detailComponents[this.listIndex].bladeIndexToNavigateTo : this.parent.formIndex + 1,
				"00000000-0000-0000-0000-000000000000", this.parent.formIndex);
	}

  constructor(private apiService: ApiService,
	  private messageService?: NbToastrService,
	  public auth?: IdentityAuthService) { }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.loading = true;
    this.apiService.get(`/api/stockItemType/Dropdown`).
      subscribe(results => {
        this.stockItemTypes = results;
        this.stockItemTypes.unshift({ id: null, name: "All Categories" });
      })
    this.apiService.post(`/api/stockItem/detailedList`, {
      query: this.search,
      startRecNum: this.currentStartRec,
      rows: this.rowsPerPage,
      filteredSuppliers: this.filteredSuppliers,
      stockItemTypeId: this.stockItemTypeId
    })
      .subscribe(results => {
        let stockItems = results.list;
        this.totalRecords = results.totalRows;
        this.filteredBrands = new Array();
        this.stockItems = new Array();
        this.stockItems = stockItems;
        this.stockItems.forEach(o => {
          if (o.fileCabinets)
            o.images = o.fileCabinets.map(o => {
              return { source: this.apiService.appSettings.apiServiceAddress + "/api/FileCabinetDocument/getImageSmall/" + o, alt: 'Description for Image 1', title: 'Title 1' }
            });
        })
        this.loading = false;
      }, err => {
        this.messageService.danger("Could not load", "Action");
        this.loading = false;
      });
  }

  filterBrands(event) {
    this.filteredBrands = [];
    this.apiService.get(`/api/stockItem/esFilter/${event.query.toLowerCase()}`)
      .subscribe(stockItems => {
        stockItems.forEach(o => {
          this.filteredBrands.push(o)
        })
      }, err => {
        this.messageService.danger("Could not load", "Action");
      });
  }

  filterCountrySingle(event) {
    this.search = event.query;
    if (this.pager && this.pager.first != 0) {
      this.pager.first = 0;
      this.currentStartRec = 0;
    }
    this.loadData();
  }

  viewItem(item, event) {
    this.parent.navigateToIndex(this.parent.detailComponents[this.listIndex].bladeIndexToNavigateTo ? this.parent.detailComponents[this.listIndex].bladeIndexToNavigateTo : this.parent.formIndex + 1, item.id, this.parent.formIndex);
    event.stopPropagation();
  }

  pageChange(event) {
    if (event.first != this.currentStartRec) {
      try {
        var x = document.getElementsByClassName("scroll-card-body");
        x[0].scrollTo(0, 0);
      } catch  { }
    }
    this.currentStartRec = event.first;
    this.rowsPerPage = event.rows
    this.loadData();
  }

  public loadEntity() {
    this.loadData();
  }

  loadSuppliers() {
    if (!this.suppliers) {
      this.apiService.get('/api/supplier')
        .subscribe(o => {
          this.suppliers = o.map(o => {
            return { label: o.code + ' ' + o.name, value: o.id }
          })
          this.filteredSuppliers = this.suppliers.map(o => {
            return o.value
          })
          this.filterBySupplier = true;
        }, err => {

        })
    }
  }

  export() {
    var self = this;
    self.loading = true;

    self.apiService.get('/api/stockitem/export').subscribe(data => {
      debugger;
      self.messageService.success('Export has started download', 'Action');
      self.loading = false;
      const link = document.createElement('a');
      link.href = `${appSettings.apiServiceAddress}/api/fileServe/report/${data.name}`;
      link.setAttribute('visibility', 'hidden');
      link.click();
    }, err => {
        self.loading = false;
        self.messageService.danger('Could not Export', 'Action');
    })
  }
}
